module.exports = __webpack_public_path__ + "img/ic-redotpay.e0910d2b.svg";